
import axios  from 'axios'

// Sample data for questions and answers
const questionsAndAnswers = [
  {
    id: 1,
    questionText: "What is the difference between a function and a variable?",
    answerText: "A function is a block of code that can be used to perform a task. A variable is a value that can be stored in memory.",
    difficultyLevel: "Easy",
    category: "Programming",
    course: "JavaScript"
  },
  {
    id: 2,
    questionText: "What is the capital of France?",
    answerText: "The capital of France is Paris.",
    difficultyLevel: "Medium",
    category: "General Knowledge",
    course: "Geography"
  },
  // Add more sample questions and answers as needed
];

// Simulate an asynchronous API call to fetch questions
export const fetchQuestions = async (difficulty, category) => {
  // Simulate API delay with setTimeout
  return new Promise((resolve) => {
    setTimeout(() => {
      let filteredQuestions = questionsAndAnswers;
      if (difficulty) {
        filteredQuestions = filteredQuestions.filter(question => question.difficultyLevel === difficulty);
      }
      if (category) {
        filteredQuestions = filteredQuestions.filter(question => question.category === category);
      }
      resolve(filteredQuestions);
    }, 500); // Simulate 500ms delay
  });
};

// Simulate an asynchronous API call to fetch answers
export const fetchAnswers = async () => {
  // Simulate API delay with setTimeout
  return new Promise((resolve) => {
    setTimeout(() => {
      // Return only answerTexts for each question
      const answers = questionsAndAnswers.map(question => ({
        id: question.id,
        answerText: question.answerText
      }));
      resolve(answers);
    }, 500); // Simulate 500ms delay
  });
};



const uploadData = async(obj) => {
  console.log("ful data  : " + obj)
  const response = await axios.post('/api/v1/upload', obj);
  return response.data;
}

export {uploadData}